import React, { Component } from 'react'
import { observer } from 'mobx-react/index'
import object_value from '../api/object_value'
import { computed } from "mobx"
import shortid from 'shortid'

@observer
class ReviewsReviewUser extends Component {
  @computed get user() {
    return this.props.user
  }

  render () {
    let user = this.user.data

    if (!this.user.loaded) {
      return (<div />)
    }

    console.log('ReviewsReviewUser.js - user:', user)

    let surname = user.surname ? user.surname.charAt(0) + '.' : ''
    let name = user.prename + ' ' + surname

    let image_url = user.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    return [
      (<div className='b-reviews-review-header-author-picture' key={shortid.generate()} style={image_style} />),
      (<div className='b-reviews-review-header-author-name' key={shortid.generate()}>{name}</div>)
    ]
  }
}

export default ReviewsReviewUser


// WEBPACK FOOTER //
// ./src/components/ReviewsReviewUser.js